<app-header></app-header>
<ion-content class="main-conten">
  <ion-row class="">
    <ion-col size="12" size-sm="4" size-md="4" size-lg="4">
      <ion-toolbar mode="md">
        <ion-buttons slot="start">
          <ion-back-button defaultHref="/home"></ion-back-button>
        </ion-buttons>
        <ion-title class="page-title" slot="start">{{'bulkupdate' | language:'Bulk Update '}}</ion-title>
      </ion-toolbar>
    </ion-col>
  </ion-row>
  <ion-card class="card-layout card-flex">
    <ion-card-header>
      <ion-card-title class="title">{{'downloadfile' | language : 'Download File'}}</ion-card-title>
    </ion-card-header>
    <ion-item lines="none" class="ion-float-left ">
      <ion-button class=" upload-btn" (click)="exportToExcel()">
        <img src="assets/icon/exportfile.svg" width="24px" height="24px" class="me-2" />
        <ion-title class="upload-btn-text">{{'downloadsamplefile'|language:'Download sample file'}}</ion-title>
      </ion-button>
    </ion-item>
  </ion-card>
  <ion-card class="card-layout">
    <ion-card-header>
      <ion-card-title class="title">{{'uploadfile' | language : 'Upload File'}}</ion-card-title>
    </ion-card-header>
    <div class="card-flex" style="margin: 0 10px;">
      <div class="relative mb-4">
        <!-- Hidden File Input -->
        <input id="uploadfile" type="file" class="hidden" (change)="onFileChange($event)" accept=".xlsx, .xls" />

        <!-- Custom Design -->
        <label for="uploadfile" class="file-input ">
          <span class="custom-fileinput ">
            <img src="assets/icon/ph_browsers-thin.svg" width="24px" height="24px" class="me-2" />
            <span> {{'Browselist' | language:'Browse list'}}</span></span>
          <span class="file-name"> {{ selectedFileName || 'No File Chosen' }}</span>
        </label>
      </div>
      <ion-button class="upload-btn" (click)="uploadFile()">
        <img src="assets/image/upload.svg" />
        <ion-title class="ion-text-capitalize upload-btn-text">
          {{'browseupload' | language:'Browse Upload'}}
        </ion-title>
      </ion-button>
    </div>
  </ion-card>
</ion-content>